
import firebase from 'firebase/app'
import 'firebase/auth'
import { authApp } from '@/services/firebase'

import { mapGetters, mapMutations } from 'vuex'
import scrolls from '~/mixins/scrolls'
import routeQuerys from '@/mixins/routeQuerys'
import authentication from '~/mixins/authentication'
import queries from '~/mixins/queries'
import { getImageUrlPublic } from '~/logicJs/trustCenterImage'
import trustCenter from '~/mixins/trustCenter'
import { brandingDefinitions } from '~/mixins/brandingDefinitions'

export default {
  name: 'default',
  mixins: [
    routeQuerys,
    scrolls,
    authentication,
    queries,
    authentication,
    trustCenter,
    brandingDefinitions,
  ],
  data() {
    return {
      lastScrollTop: 0,

      user: null,
      showScrollToTopBtn: '',
      hideSecondaryNavbarLinks: ['Contact'],
    }
  },
  methods: {
    ...mapMutations([
      'SET_SCROLL_DIRECTION',
      'SET_CURRENT_LINK',
      'SET_TRUST_CENTER_DB',
      'SET_MAIN_LOADER',
      'SET_POPUP_EMAIL_SHOWN',
      'SET_FIREBASE_BINDINGS_RUN',
      'SET_CURRENT_USER',
      'SET_DOMAIN',
      'SET_HAS_TOP_NAVBAR_BG_IMAGE',
    ]),

    injectCustomHeadScripts() {
      if (this._customScriptsInjected) return

      const customHeadScript = this.getTrustCenterByType(
        'trustCenterSettings'
      )?.customHeadScript
      if (!customHeadScript) return

      this._customScriptsInjected = true

      // Parse HTML string into DOM structure (innerHTML won't execute scripts)
      const temp = document.createElement('div')
      temp.innerHTML = customHeadScript

      const appendToHead = (selector, clone = false) => {
        temp.querySelectorAll(selector).forEach((node) => {
          // Recreate script elements to make browser execute them
          const element = clone
            ? node.cloneNode(true)
            : document.createElement('script')
          if (!clone) {
            Array.from(node.attributes).forEach((attr) =>
              element.setAttribute(attr.name, attr.value)
            )
            element.textContent = node.textContent
          }
          document.head.appendChild(element)
        })
      }

      appendToHead('script')
      appendToHead('noscript', true)
    },
    checkImageExists(url) {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
        img.src = url
      })
    },
    async bgColorOrImageIfExist() {
      const fallbackColor = '#E8F1FA'
      let finalTopNavbarBg = null

      const topNavbarBg1920x205 = getImageUrlPublic(
        'trust-center-topbar-1920x205.png',
        this.GET_TEAMID
      )
      const topNavbarBg1200x170 = getImageUrlPublic(
        'trust-center-topbar-1200x170.png',
        this.GET_TEAMID
      )
      const topNavbarBg950x124 = getImageUrlPublic(
        'trust-center-topbar-950x124.png',
        this.GET_TEAMID
      )
      const topNavbarBg637x122 = getImageUrlPublic(
        'trust-center-topbar-637x122.png',
        this.GET_TEAMID
      )

      const element = document.querySelector('.top-navbar')
      const mainNavbarColor =
        this.getBrending?.sectionsBgColor?.topNavbarBg || fallbackColor
      const topNavbarBgGradient =
        this.getBrending?.sectionsBgColor?.topNavbarBgGradient

      if (this.windowWidth > 1200) {
        finalTopNavbarBg = topNavbarBg1920x205
      } else if (this.windowWidth <= 1200 && this.windowWidth > 950) {
        finalTopNavbarBg = topNavbarBg1200x170
      } else if (this.windowWidth <= 950 && this.windowWidth > 637) {
        finalTopNavbarBg = topNavbarBg950x124
      } else if (this.windowWidth <= 637) {
        finalTopNavbarBg = topNavbarBg637x122
      }

      if (!element) return

      const imageExists = finalTopNavbarBg
        ? await this.checkImageExists(finalTopNavbarBg)
        : false

      this.SET_HAS_TOP_NAVBAR_BG_IMAGE(imageExists)

      if (imageExists) {
        element.style.background = ''
        element.style.backgroundImage = `url('${finalTopNavbarBg}')`
        element.style.backgroundSize = 'cover'
        element.style.backgroundPosition = 'center center'
        element.style.backgroundRepeat = 'no-repeat'
        element.style.backgroundAttachment = 'scroll'
        if (this.windowWidth <= 637) {
          element.style.backgroundSize = '100% 100%'
        }
      } else {
        element.style.backgroundImage = 'none'
        element.style.background = topNavbarBgGradient
          ? `linear-gradient(to right, ${topNavbarBgGradient?.firstColor}, ${topNavbarBgGradient?.secondColor})`
          : mainNavbarColor || '#26284d'
      }
    },

    handleScroll(e) {
      const currentScroll = e.target.scrollTop
      if (currentScroll > this.lastScrollTop + 5) {
        // Scrolling down
        this.SET_SCROLL_DIRECTION('down')
      } else if (currentScroll < this.lastScrollTop - 5) {
        // Scrolling up
        this.SET_SCROLL_DIRECTION('up')
      }

      this.lastScrollTop = currentScroll
    },

    getRadius(shape) {
      switch (shape) {
        case 'Straight corners':
          return '0px'
          break
        case 'Rounded corners':
          return '6px'
          break
        case 'Round corners':
          return '50px'
          break

        default:
          break
      }
    },

    initializeAuth() {
      console.log('Initializing auth', this.$route.query)
      firebase.auth(authApp).onAuthStateChanged(async (user) => {
        console.log('Inside onAuthStateChanged:', user)
        try {
          await this.login(user)
        } catch (error) {
          // login() already handled the UX (loader, notification) and
          // reported to Sentry; it re-throws only so programmatic callers
          // (ReqDocs.vue) can react. Nothing more to do at top level —
          // swallow to avoid an unhandled rejection in this async callback.
          console.error('onAuthStateChanged: login failed', error?.code)
        }
      })
    },

    setCssVar(property, value) {
      document.documentElement.style.setProperty(property, value)
    },

    setBrandingColor(variable, path, defaultValue) {
      this.setCssVar(variable, _.get(this.getBrending, path) || defaultValue)
    },

    setBrandingGradientColor(
      variable,
      gradientFlagPath,
      gradientColorsPath,
      colorPath,
      defaultValue
    ) {
      const isGradient = _.get(this.getBrending, gradientFlagPath)
      if (isGradient) {
        const firstColor = _.get(
          this.getBrending,
          `${gradientColorsPath}.firstColor`
        )
        const secondColor = _.get(
          this.getBrending,
          `${gradientColorsPath}.secondColor`
        )
        this.setCssVar(
          variable,
          `linear-gradient(to right, ${firstColor}, ${secondColor})`
        )
      } else {
        this.setCssVar(
          variable,
          _.get(this.getBrending, colorPath) || defaultValue
        )
      }
    },

    setBrandingRadius(variable, path, defaultValue) {
      this.setCssVar(
        variable,
        this.getRadius(_.get(this.getBrending, path)) || defaultValue
      )
    },

    setBrandingFont(variable, path, defaultValue) {
      this.setCssVar(variable, _.get(this.getBrending, path) || defaultValue)
    },

    setBrandingTwoColorOptions(variable, path1, path2, defaultValue) {
      this.setCssVar(
        variable,
        _.get(this.getBrending, path1) ||
          _.get(this.getBrending, path2) ||
          defaultValue
      )
    },
  },
  computed: {
    ...mapGetters([
      'GET_CURRENT_LINK',
      'GET_IS_HAM_MENU_OPEN',
      'GET_CURRENT_USER',
      'GET_IS_AI_ANSWERS_DRAWER_OPEN',
      'GET_TRUST_CENTER_DB',
      'GET_MAIN_LOADER',
      'GET_TEAMID',
      'GET_TOKEN',
      'GET_SCROLL_DIRECTION',
      'GET_HAS_TOP_NAVBAR_BG_IMAGE',
    ]),
    windowWidth() {
      return this.$store.getters.GET_WINDOW_WIDTH
    },

    isTopNavbarEmpty() {
      // The top-navbar banner is empty (and we collapse its grid row so it
      // leaves no gap) unless it has a background image, the trust-center logo
      // (non "different logo design" TCs), the upload questionnaire button, the
      // edit overlay (admin side) or the AI search bar. On mobile the search
      // bar always lives in MainNavbar; on desktop it stays here unless hidden
      // or moved into MainNavbar via the "AI Search Bar Location" setting.
      const isMobile = this.windowWidth <= this.BREAKPOINTS.MD
      const hasBgImage = this.GET_HAS_TOP_NAVBAR_BG_IMAGE
      const hasLogo = !this.getTidForDiffrentLogoDesign && !!this.GET_TEAMID
      const hasUploadButton = this.showUploadQuestionnaireButton
      const hasEditUi = this.isEdit && this.windowWidth > 500
      // On mobile the search is relocated into the scrollable content
      // (MobileSearchBar), so it no longer occupies the top-navbar row — the
      // row can collapse. On desktop the search lives here unless moved into
      // MainNavbar.
      const hasSearch = this.shouldHideSearchBar
        ? false
        : isMobile
        ? false
        : !this.isSearchBarInMainNavbar
      return (
        !hasBgImage && !hasLogo && !hasUploadButton && !hasEditUi && !hasSearch
      )
    },

    brandingGradientColors() {
      return this.brandingDefinitions.gradients.map((gradient) => [
        gradient.cssAttribute,
        `sectionsGradientBg.${gradient.prefix}`,
        `sectionsBgColor.${gradient.prefix}Gradient`,
        `sectionsBgColor.${gradient.prefix}`,
        gradient.hasOwnProperty('defaultColor')
          ? gradient.defaultColor
          : '#fff',
      ])
    },
  },
  mounted() {
    let mainNuxtContent = document.querySelector('#main-content')
    mainNuxtContent.addEventListener('scroll', () => {
      if (mainNuxtContent.scrollTop > 50) {
        this.showScrollToTopBtn = true
      } else {
        this.showScrollToTopBtn = false
      }
    })
    const container = this.$refs?.mainScrollContainer
    if (container) {
      container.addEventListener('scroll', this.handleScroll)
    }
  },
  async created() {
    if (
      'domain' in this.$route.query &&
      window.location.hostname.includes('localhost')
    ) {
      this.SET_DOMAIN(this.$route.query.domain)
    } else if (!window.location.hostname.includes('localhost')) {
      this.SET_DOMAIN(window.location.hostname)
    }

    await this.fetchTrustCenterData(true, '/trust-center-public/init')

    this.initializeAuth()

    this.SET_CURRENT_LINK({
      name: this.convertValueToName(this.$route.name),
      value: this.$route.name,
    })
  },
  watch: {
    windowWidth(newVal) {
      if (newVal) {
        this.bgColorOrImageIfExist()
      }
    },
    GET_TRUST_CENTER_DB: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal) && newVal.length > 0) {
          console.log('Inside watch GET_TRUST_CENTER_DB:', newVal)
          this.$nextTick(() => {
            this.SET_MAIN_LOADER(false)
          })
        }
        this.bgColorOrImageIfExist()
      },
      immediate: true,
      deep: true,
    },
    getBrending(newVal) {
      if (!newVal || _.isEmpty(newVal)) {
        return
      }
      console.log('Inside watch getBrending:', newVal)

      // Special cases with complex logic
      const btnTextColor =
        _.get(this.getBrending, 'colors.buttonColorCustom') ??
        _.get(this.getBrending, 'colors.buttonColorText')
      this.setCssVar(
        '--simple-btn-text-color',
        btnTextColor?.includes('rgb')
          ? btnTextColor
          : btnTextColor === undefined
          ? '#fff'
          : btnTextColor.includes('White')
          ? '#fff'
          : '#000'
      )

      const activeColorText = _.get(
        this.getBrending,
        'navigation.activeColorText'
      )
      this.setCssVar(
        '--navbar-active-color',
        activeColorText === undefined
          ? '#000 !important'
          : activeColorText.includes('White')
          ? '#000'
          : '#000'
      )

      const hoverColorText = _.get(
        this.getBrending,
        'navigation.hoverColorText'
      )
      this.setCssVar(
        '--navbar-hover-color',
        hoverColorText === undefined
          ? '#000'
          : hoverColorText.includes('White')
          ? '#fff'
          : '#000'
      )

      // Refactored loops
      const brandingColors = [
        ['--simple-btn-bg-color', 'colors.buttonColor', '#4577F2'],
        ['--simple-btn-border-color', 'colors.buttonBorderColor', '#4577F2'],
        ['--navbar-bg-hover-color', 'navigation.hoverColor', '#dbe4ff'],
        ['--main-content-bg-color', 'mainContentBg', '#fff'],
        ['--navbar-bg-active-color', 'sidebarLinkActiveColor'],
        ['--sidebar-link-color', 'sidebarLinkColor', '#000'],
        ['--group-color-overview', 'groupColorOverview', '#000'],
        ['--group-active-color-overview', 'groupActiveColorOverview', '#000'],
        ['--group-color-documents', 'groupActiveColorDocuments', '#000'],
        ['--group-active-color-documents', 'groupColor', '#000'],
        ['--group-color-controls', 'groupColorControls', '#000'],
        ['--group-active-color-controls', 'groupActiveColorControls', '#000'],

        ['--document-title-color', 'documentTitleColor', '#000'],
        [
          '--document-checkbox-border-color',
          'documentCheckboxBorderColor',
          '#7b37e2',
        ],
        ['--document-checkbox-bg-color', 'documentCheckboxBgColor', '#7b37e2'],
        [
          '--document-checkbox-check-color',
          'documentCheckboxCheckColor',
          '#ffffff',
        ],
        ['--document-title-font-size', 'documentTitleFontSize', '22px'],
        // --document-title-color-overview / --document-title-font-size-overview
        // moved to brandingTwoColorOptions: they fall back to the docs-page
        // values so overview titles keep inheriting them unless overridden.
        ['--control-title-color', 'controlTitleColor', '#000'],
        ['--update-title-color', 'updateTitleColor', '#000'],
        ['--update-title-color-new', 'updateTitleColorNew', '#000'],
        [
          '--compliance-header-page-color',
          'overview.complianceCardNewHeaderColor',
          '#000',
        ],
        [
          '--customers-header-page-color',
          'overview.customersCardNewHeaderColor',
          '#000',
        ],
        ['--team-header-page-color', 'overview.teamCardNewHeaderColor', '#000'],
        [
          '--subprocessors-header-page-color',
          'overview.subprocessorsCardNewHeaderColor',
          '#000',
        ],
        [
          '--compliance-caption-page-color',
          'overview.complianceCardNewCaptionColor',
          '#000',
        ],
        [
          '--customers-caption-page-color',
          'overview.customersCardNewCaptionColor',
          '#000',
        ],
        [
          '--team-caption-page-color',
          'overview.teamCardNewCaptionColor',
          '#000',
        ],
        [
          '--subprocessors-caption-page-color',
          'overview.subprocessorsCardNewCaptionColor',
          '#000',
        ],
        ['--control-title-font-size', 'controlTitleFontSize', '22px'],
        [
          '--compliance-header-page-font-size',
          'complianceHeaderPageFontSize',
          '22px',
        ],
        [
          '--customers-header-page-font-size',
          'customersHeaderPageFontSize',
          '22px',
        ],
        ['--team-header-page-font-size', 'teamHeaderPageFontSize', '22px'],
        [
          '--subprocessors-header-page-font-size',
          'subprocessorsHeaderPageFontSize',
          '22px',
        ],
        [
          '--compliance-see-more-link-color',
          'complianceSeeMoreLinkColor',
          '#4577F2',
        ],
        [
          '--document-see-more-link-color',
          'documentSeeMoreLinkColor',
          '#4577F2',
        ],
        [
          '--customers-see-more-link-color',
          'customersSeeMoreLinkColor',
          '#4577F2',
        ],
        ['--team-see-more-link-color', 'teamSeeMoreLinkColor', '#4577F2'],
        [
          '--subprocessors-see-more-link-color',
          'subprocessorsSeeMoreLinkColor',
          '#4577F2',
        ],
        ['--compliance-caption-font-size', 'complianceCaptionFontSize', '14px'],
        ['--customers-caption-font-size', 'customersCaptionFontSize', '14px'],
        ['--team-caption-font-size', 'teamCaptionFontSize', '14px'],
        [
          '--subprocessors-caption-font-size-page',
          'subprocessorsCaptionFontSize',
          '14px',
        ],
        ['--update-title-font-size', 'updateTitleFontSize', '22px'],
        ['--update-title-font-size-new', 'updateTitleFontSizeNew', '22px'],
        [
          '--control-title-caption-font-size',
          'controlTitleCaptionFontSize',
          '14px',
        ],
        [
          '--update-title-caption-font-size',
          'updateTitleCaptionFontSize',
          '14px',
        ],
        [
          '--update-title-caption-font-size-new',
          'updateTitleCaptionFontSizeNew',
          '14px',
        ],
        ['--update-title-date-font-size', 'updateTitleDateFontSize', '14px'],
        [
          '--update-title-date-font-size-new',
          'updateTitleDateFontSizeNew',
          '14px',
        ],
        ['--control-title-caption-color', 'controlTitleCaptionColor', '#000'],
        ['--update-title-caption-color', 'updateTitleCaptionColor', '#000'],
        [
          '--update-title-caption-color-new',
          'updateTitleCaptionColorNew',
          '#000',
        ],
        [
          '--control-card-new-bg-color',
          'sectionsBgColor.controlCardNew',
          '#fff',
        ],
        [
          '--compliance-card-new-bg-color',
          'sectionsBgColor.complianceCardNew',
          '#fff',
        ],
        [
          '--customers-card-new-bg-color',
          'sectionsBgColor.customersCardNew',
          '#fff',
        ],
        ['--team-card-new-bg-color', 'sectionsBgColor.teamCardNew', '#fff'],
        [
          '--subprocessors-card-new-bg-color',
          'sectionsBgColor.subprocessorsCardNew',
          '#fff',
        ],
        [
          '--compliance-card-new-border-color',
          'bordersColor.complianceCardNew',
          '#ccc',
        ],
        [
          '--customers-card-new-border-color',
          'bordersColor.customersCardNew',
          '#ccc',
        ],
        ['--team-card-new-border-color', 'bordersColor.teamCardNew', '#ccc'],
        [
          '--subprocessors-card-new-border-color',
          'bordersColor.subprocessorsCardNew',
          '#ccc',
        ],

        [
          '--updates-card-new-bg-color',
          'sectionsBgColor.updatesCard',
          '#f5f5f5',
        ],
        [
          '--updates-card-new-bg-color-page',
          'sectionsBgColor.updatesCardNew',
          '#f5f5f5',
        ],

        ['--security-config-color', 'securityConfigColor', '#000'],
        ['--security-config-font-size', 'securityConfigFontSize', '22px'],
        ['--security-config-color-new', 'securityConfigColorNew', '#000'],
        [
          '--security-config-font-size-new',
          'securityConfigFontSizeNew',
          '22px',
        ],
        [
          '--data-types-item-color',
          'overview.dataTypeRightCaptionColor',
          '#000',
        ],
        [
          '--certifications-border-color',
          'bordersColor.certifications',
          '#e3e3e3',
        ],

        ['--about-company-border-color', 'bordersColor.aboutCompany', 'none'],
        [
          '--data-types-item-font-size',
          'overview.dataTypeRightCaptionFontSize',
          '14px',
        ],
        [
          '--data-types-header-color',
          'overview.dataTypeRightHeaderColor',
          '#000',
        ],
        [
          '--data-types-header-font-size',
          'overview.dataTypeRightHeaderFontSize',
          '16px',
        ],

        [
          '--main-input-placeholder-border-color',
          'mainInputPlaceholderBorderColor',
          'none',
        ],
        ['--powered-color', 'overview.footerHeaderColor', '#000'],
        ['--security-config-link-color', 'securityConfigLinkColor', '#4577F2'],
        [
          '--security-config-link-color-new',
          'securityConfigLinkColorNew',
          '#4577F2',
        ],
        ['--footer-caption-color', 'securityConfigLinkColor', '#1262cd'],
        [
          '--customers-caption-color',
          'overview.customersCardCaptionColor',
          '#000',
        ],
        ['--team-caption-color', 'overview.teamCardNewCaptionColor', '#000'],
        [
          '--subprocessors-caption-color',
          'overview.subprocessorsCardCaptionColor',
          '#000',
        ],
        [
          '--customers-caption-font-size',
          'overview.customersCardCaptionFontSize',
          '#000',
        ],
        ['--team-caption-color', 'overview.teamCardNewCaptionColor', '#000'],
        [
          '--subprocessors-caption-color',
          'overview.subprocessorsCardCaptionColor',
          '#000',
        ],
        [
          '--subprocessors-caption-font-size',
          'overview.subprocessorsCardCaptionFontSize',
          '14px',
        ],

        ['--global-font-color', 'fonts.globalColor', '#030303'],
        ['--global-paragraphs-color', 'fonts.paragraphsGlobalColor', '#000'],
        ['--global-headers-tabs-color', 'fonts.globalHeadersColor', '#26284d'],
        ['--main-input-placeholder-color', 'mainInputPlaceholderColor', '#000'],
        ['--doc-card-new-border-color', 'bordersColor.docCardNew', '#cccccc'],
        [
          '--doc-card-new-border-color-overview',
          'bordersColor.docCardNewOverview',
          '#cccccc',
        ],
        [
          '--control-card-new-border-color',
          'bordersColor.controlCardNew',
          'none',
        ],
        ['--updates-card-new-border-color', 'bordersColor.updatesCard', 'none'],
        [
          '--updates-card-new-border-color-page',
          'bordersColor.updatesCardNew',
          'none',
        ],
        ['--customers-border-color', 'bordersColor.customersCard', '#e3e3e3'],
        ['--team-border-color', 'bordersColor.teamCard', '#e3e3e3'],
        [
          '--subprocessors-border-color',
          'bordersColor.subprocessorsCard',
          '#e3e3e3',
        ],
        [
          '--security-config-border-color',
          'bordersColor.securityConfig',
          '#e3e3e3',
        ],
        [
          '--security-config-border-color-new',
          'bordersColor.securityConfigNew',
          '#e3e3e3',
        ],
        [
          '--subprocessors-border-color',
          'bordersColor.subprocessorsCard',
          '#e3e3e3',
        ],
        [
          '--main-input-placeholder-icon-color',
          'mainInputPlaceholderIconColor',
          '#000',
        ],
        ['--trust-center-logo-color', 'colors.trustCenterLogoColor', '#000'],
        [
          '--trust-center-separator-color',
          'colors.trustCenterSeparatorColor',
          '#000',
        ],
        ['--bottom-navbar-bg-color', 'colors.bottomNavbarBgColor', '#ccc'],
        ['--see-more-link-color', 'seeMoreLinkColor', '#4577F2'],
        ['--control-title-link-color', 'controlTitleLinkColor', '#4577F2'],
        ['--update-title-link-color', 'updateTitleLinkColor', '#4577F2'],
        ['--update-title-link-color-new', 'updateTitleLinkColorNew', '#4577F2'],
        ['--update-title-date-color', 'updateTitleDateColor', '#000'],
        ['--update-title-date-color-new', 'updateTitleDateColorNew', '#000'],
        ['--logo-link-color', 'logoLinkColor', '#4577F2'],
        ['--logo-text-color', 'logoTextColor', '#000'],
        ['--data-types-border-color', 'bordersColor.dataTypeRight', '#e3e3e3'],
        ['--control-title-page-color', 'controlTitlePageColor', '#000'],
        ['--control-title-page-font-size', 'controlTitlePageFontSize', '22px'],
        [
          '--control-title-page-caption-font-size',
          'controlPageCaptionFontSize',
          '14px',
        ],
        [
          '--control-title-page-caption-color',
          'controlPageCaptionColor',
          '#000',
        ],
      ]
      brandingColors.forEach((args) => this.setBrandingColor(...args))

      this.brandingGradientColors.forEach((args) =>
        this.setBrandingGradientColor(...args)
      )

      const brandingRadiuses = [
        ['--simple-btn-border-radius', 'buttonShape.shape', '6px'],
        ['--input-border-radius', 'inputShape.shape', '50px'],
        ['--comp-logo-border-radius', 'compLogoShape.shape', '4px'],
      ]
      brandingRadiuses.forEach((args) => this.setBrandingRadius(...args))

      const brandingFonts = [
        [
          '--global-font-family',
          'fonts.globalFont',
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Open Sans", sans-serif',
        ],
        [
          '--global-paragraphs-font',
          'fonts.paragraphsGlobalFont',
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Open Sans", sans-serif',
        ],
        ['--global-headers-font', 'fonts.globalHeadersFont', 'Segoe UI'],
      ]
      brandingFonts.forEach((args) => this.setBrandingFont(...args))

      // Headers font weight (brandbook requests like JFrog's "Open Sans
      // Bold"). Only set when configured so existing trust centers keep the
      // per-element defaults (h1 600, h2-h6 700, page titles 400).
      const headersWeight = _.get(this.getBrending, 'fonts.globalHeadersWeight')
      if (headersWeight) {
        this.setCssVar('--global-headers-weight', headersWeight)
      } else {
        // Live-revert when the admin switches back to "Default" in the EditUi
        // (an empty custom property would NOT trigger the var() fallbacks).
        document.documentElement.style.removeProperty('--global-headers-weight')
      }

      const brandingTwoColorOptions = [
        [
          '--global-headers-color',
          'fonts.globalHeadersColor',
          'fonts.globalHeadersColor',
          '#26284d',
        ],
        [
          '--overview-headers-color',
          'overview.headersFontColor',
          'fonts.globalHeadersColor',
          '#26284d',
        ],
        [
          '--global-caption-color',
          'fonts.globalHeadersColor',
          'fonts.globalHeadersColor',
          '#26284d',
        ],
        [
          '--overview-caption-color',
          'overview.captionFontColor',
          'fonts.globalHeadersColor',
          '#26284d',
        ],
        // Overview document titles historically inherited the Documents-page
        // styling (the overview class was never applied - see DocsContainerSlider
        // getTitleClasses). Now that the class is back, keep that inheritance as
        // the fallback so existing trust centers don't change appearance: the
        // overview-specific key wins when set, otherwise the docs-page key.
        [
          '--document-title-color-overview',
          'documentTitleOverviewColor',
          'documentTitleColor',
          '#000',
        ],
        [
          '--document-title-font-size-overview',
          'documentTitleOverviewFontSize',
          'documentTitleFontSize',
          '22px',
        ],
      ]
      brandingTwoColorOptions.forEach((args) =>
        this.setBrandingTwoColorOptions(...args)
      )
    },
    $route: {
      handler(to, from) {
        if (!_.isEqual(to, from)) {
          if (this.GET_CURRENT_USER?.email) {
            this.auditLogCreate({
              action: 'visitPage',
              value: to.name,
            })
          }
          this.SET_POPUP_EMAIL_SHOWN(false) // Reset open signup
          this.$nextTick(() => {
            const mainContent = document.querySelector('.main-content')
            if (mainContent) {
              // Use requestAnimationFrame for smoother animation
              requestAnimationFrame(() => {
                mainContent.scrollTo({
                  top: 0,
                  behavior: 'instant', // Change to instant to avoid animation conflicts
                })
              })
            }
          })
        }
      },
      immediate: true,
    },
    GET_TOKEN: {
      async handler(newVal) {
        if (!_.isEmpty(newVal)) {
          this.auditLogCreate({
            action: 'visitPage',
            value: this.$route.name,
          })
          console.log('Inside watch GET_TOKEN : User signed in:', newVal)
          if (!this.GET_CURRENT_USER?.isAnonymous) {
            this.SET_FIREBASE_BINDINGS_RUN(false)
            await this.fetchTrustCenterData(false)
            this.SET_FIREBASE_BINDINGS_RUN(true)
          }

          let urlFavicon = getImageUrlPublic('favicon.ico', this.GET_TEAMID)
          this.$setFavicon(urlFavicon)
          let nameTrustCenter = this.getTrustCenterByType(
            'trustCenterSettings'
          )?.trustCenterName
          if (nameTrustCenter)
            this.$setTitle(
              `${this.trustCenterSettingsComputed?.trustCenterName} | Powered by Vendict`
            )
          this.injectCustomHeadScripts()
          this.SET_FIREBASE_BINDINGS_RUN(true)
          this.SET_POPUP_EMAIL_SHOWN(false) // Reset open signup
        }
      },
      immediate: true,
      deep: true,
    },
  },

  beforeDestroy() {
    const container = this.$refs.mainScrollContainer
    if (container) {
      container.removeEventListener('scroll', this.handleScroll)
    }
  },
  components: {
    MainNavbar: () =>
      import(
        /* webpackChunkName: 'MainNavbar' */ '@/components/deafaultLayout/mainNavbar/MainNavbar.vue'
      ),
    DrawerUploadQuestionnaire: () =>
      import(
        /* webpackChunkName: 'DrawerUploadQuestionnaire' */ '@/components/uploadQuestionnaire/DrawerUploadQuestionnaire.vue'
      ),
    EditUi: () =>
      import(/* webpackChunkName: 'EditUi' */ '@/components/editUi/EditUi.vue'),
    TopNavbar: () =>
      import(
        /* webpackChunkName: 'TopNavbar' */ '@/components/deafaultLayout/mainNavbar/TopNavbar.vue'
      ),
    DialogEmailRequired: () =>
      import(
        /* webpackChunkName: 'DialogEmailRequired' */ '@/components/DialogEmailRequired.vue'
      ),
    SecondaryNavbar: () =>
      import(
        /* webpackChunkName: 'MainNavbar' */ '@/components/deafaultLayout/secondaryNavbar/SecondaryNavbar.vue'
      ),
    MainSidebar: () =>
      import(
        /* webpackChunkName: 'MainSidebar' */ '@/components/deafaultLayout/mainSidebar/MainSidebar.vue'
      ),
    ScrollToTopBtn: () =>
      import(
        /* webpackChunkName: 'ScrollToTopBtn' */ '@/components/reusables/scrollToTopBtn/ScrollToTopBtn.vue'
      ),
    HamMenu: () =>
      import(
        /* webpackChunkName: 'HamMenu' */ '@/components/deafaultLayout/hamMenu/HamMenu.vue'
      ),
    MobileSearchBar: () =>
      import(
        /* webpackChunkName: 'MobileSearchBar' */ '@/components/deafaultLayout/mobileSearch/MobileSearchBar.vue'
      ),
    AiDrawer: () =>
      import(
        /* webpackChunkName: 'AiDrawer' */ '@/components/searchResults/AiDrawer.vue'
      ),
    Footer: () =>
      import(/* webpackChunkName: 'Footer' */ '@/components/footer/Footer.vue'),
  },
}
